<template>
  <iColumn gap="small" width="fill">
    <iRow
      v-for="(story, idx) in placeholderStories"
      :key="idx"
      gap="small"
      width="fill"
      :style-overrides="{
        paddingTop: 'small',
        paddingBottom: 'small',
        paddingLeft: 'small',
        paddingRight: 'small',
        borderRadius: 'standard',
        backgroundColor: '#f4f5f7',
      }"
    >
      <iColumn gap="extraSmall" width="fill">
        <iText font-weight="strong">
          {{ story.title }}
        </iText>
        <iText variant="subtle" font-size="small">
          ❤ {{ story.numLikes }} likes
        </iText>
      </iColumn>
    </iRow>
  </iColumn>
</template>

<script>
// SmartFeedV2 + smart-feed feed stores live outside the editor
// directory tree. Static example list inside the canvas preview.
import { DynamicElementMixin } from "%/dynamic-component-editor/mixins/dynamic-element-mixin";
import LayoutWidth from "%/dynamic-component-editor/options/layout-width";
import EmptyStateText from "%/dynamic-component-editor/options/empty-state-text";

export default {
  name: "StoriesUserLoved",
  mixins: [
    DynamicElementMixin,
  ],
  elementPanelSettings: {
    displayName: "Stories User Loved",
    displayIcon: "hamburger",
    elementGroup: "storiesUserLovedElements",
    elementType: "element",
  },
  options: [
    new LayoutWidth({
      "default": "fill",
      "hover": "fill",
    }, true),
    new EmptyStateText({ "default": "User has not loved any stories yet." }),
  ],
  computed: {
    placeholderStories() {
      return [
        { title: "How to slow down without losing speed", numLikes: 482 },
        { title: "Five tools I trust", numLikes: 211 },
      ];
    },
  },
};
</script>
